/* global swal, _, angular */
import './style.less';
import tourText from './tourText';
import { deliveryMethods } from '@prolaera/library';

export default function(
  $log,
  $q,
  $timeout,
  $state,
  $stateParams,
  $uibModal,
  $transitions,
  Swal,
  Upload,
  ApiClass,
  ProfileClass,
  ResolveClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.tourText = tourText;

  const profile_uid = $stateParams.employeeID || $stateParams.id;
  const { profile, company } = ProfileClass.profileComplete;
  const manage = ResolveClass.isManageRoute();

  const companyPreferences =
    company && 'preferences' in company && 'certificates' in company.preferences
      ? company.preferences.certificates
      : {};

  if ($stateParams.source) vm.adminView = $stateParams.source.indexOf('admin') > -1;

  vm.params = $stateParams;

  // Onboarding Top
  $transitions.onExit({ exiting: 'app.users.certificates.hours' }, () => {
    if (vm.tour) vm.tour.end();
  });
  vm.tourReady = tour => (vm.tour = tour);

  vm.startTour = init => {
    if (!init || (init && $stateParams.tour === 'start')) vm.tour.start();
  };
  // Onboarding Bottom

  vm.selectFile = file => (vm.fileToUpload = file);

  vm.removeFile = () => (vm.fileToUpload = false);

  vm.uploadPdf = file => {
    vm.pdfProgress = 'Uploading...';
    vm.uploadBtn = true;
    ApiClass.companiesIdTypePut(
      { manage, id: ProfileClass.company_id, type: 'policies' },
      {
        profile_uid,
        policy: 'certificate',
        cert_id: false,
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(({ data: { item: s3Policy } }) => {
        vm.s3Policy = s3Policy;
        return Upload.upload({
          url: s3Policy.filePolicy.action,
          data: s3Policy.filePolicy.fields,
          file: file,
          method: 'POST',
          skipAuthorization: true
        })
          .then(
            function() {
              vm.fileToUpload.uploaded = true;
              vm.uploadBtn = false;
              vm.formData.link = s3Policy.link;
              vm.formData.upload = true;
              vm.pdfProgress = 'Uploaded';
              vm.certificatePreview = true;
            },
            function(resp) {
              vm.uploadBtn = false;
              $log.error('Error status: ' + resp.status);
              throw new Error(`PDF UPLOADING ERROR ${$stateParams.id}`);
            },
            function(evt) {
              const pdfStaus = parseInt((100.0 * evt.loaded) / evt.total);
              vm.pdfProgress = `${pdfStaus}%`;
            }
          )
          .catch(error => {
            vm.uploadBtn = false;
            $log.error(error);
            throw error;
          });
      })
      .catch(error => {
        vm.uploadBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function validateSponsorInfo({ sponsors_types, sponsors }) {
    let valid = false;

    if (sponsors_types) {
      for (const sponsor in sponsors_types) {
        if (sponsors_types[sponsor]) valid = true;
      }
    }

    if (sponsors) {
      for (const sponsor in sponsors) {
        if (sponsor !== 'name' && sponsors[sponsor]) valid = true;
      }
    }

    return valid;
  }

  function validateFileUpload({ pdf_uploaded }) {
    let valid = !(!profile.admin && !profile.team_leader && companyPreferences.requireDocumentUpload);

    if (pdf_uploaded) valid = true;

    return valid;
  }

  vm.submit = function(formData) {
    formData.hours_basic = formData.formData.modifiedStates.reduce((obj, state) => {
      obj[state.reg_id] = state.hours;
      return obj;
    }, {});

    Object.keys(formData.sponsors).forEach(id => {
      if (!formData.sponsors[id] || formData.sponsors[id].length < 1) delete formData.sponsors[id];
    });

    formData.delivery_uid = parseInt(formData.delivery_uid);

    const params = {
      profile_uid,
      cert: formData.cert,
      date: new Date(formData.completionDate).toISOString(),
      delivery: vm.deliveryDict[formData.delivery_uid].name,
      delivery_uid: formData.delivery_uid,
      hours: formData.hours,
      hours_basic: formData.hours_basic || {},
      location: formData.location,
      sponsors_types: formData.sponsors_types,
      sponsor: formData.sponsors.name,
      sponsors: formData.sponsors || {}
    };

    params.delivery_date = formData.startDate ? new Date(formData.startDate).toISOString() : null;

    if (formData.link) {
      params.pdf_uploaded = true;
      params.pdf = formData.link;
    }

    if (!validateSponsorInfo(params))
      return Swal.alert('Hold Up!', 'Please enter sponsor information or select "None Provided".', 'info');
    if (!validateFileUpload(params)) return Swal.alert('Hold Up!', 'Please upload a copy of your certificate.', 'info');

    const title =
      companyPreferences.applyApprovedOnly && !profile.admin && !profile.team_leader
        ? 'Your certificate has been submitted for approval!'
        : 'Certificate has been submitted!';

    vm.submitBtn = true;

    ApiClass.usersIdTypePut({ id: profile_uid, type: 'certificates', manage: false }, params)
      .then(() => {
        vm.submitBtn = false;
        delete vm.formData;
        swal({
          type: 'success',
          title,
          showCancelButton: true,
          confirmButtonText: 'Add More Hours',
          cancelButtonText: "I'm Done",
          confirmButtonColor: '#1c84c6',
          cancelButtonColor: '#C4C4C4'
        }).then(result => {
          if (result.value) return $state.reload();
          if ($stateParams.source && $stateParams.source.toLowerCase() === 'admin-profiles')
            return $state.go('app.admin.employees.profile');
          if ($stateParams.employeeID) return $state.go('app.admin.employees.employee.certificates');
          return $state.go('app.users.dashboard', { id: profile_uid });
        });
      })
      .catch(error => {
        vm.submitBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Add Cert Component Activated');
    vm.loaded = false;
    vm.certificatePreview = false;
    vm.error = {};
    vm.fileToUpload = false;
    vm.submitBtn = false;
    vm.collapsedCustomAccreditation = false;
    vm.formData = {};
    ApiClass.usersIdGet({ id: profile_uid, manage: false }, {}, { queryParams: { 'include:withchildren': true } })
      .then(({ data: { item: profile } }) => {
        vm.profile = profile;
        vm.formData = angular.copy(profile);
        vm.formData.sponsors_types = {};
        vm.formData.sponsors = {};
        vm.formData.hours = [{}];
        vm.formData.hours_basic = {};
        vm.formData.startDate = undefined; // hide in form / may enable this later with company settings;
        vm.formData.completionDate = moment()
          .startOf('day')
          .toDate();
        vm.deliveryMethods = deliveryMethods;

        vm.deliveryDict = _.keyBy(deliveryMethods, 'key');

        vm.loaded = true;
      })
      .catch(error => {
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/addCert/controller.js